import { Breadcrumbs } from '../components/Breadcrumbs'
import { ContentCard } from '../components/ContentCard'
import { CONTENTS } from '../data/content'
import { useSeo } from '../hooks/useSeo'

export function LyricsPage() {
  useSeo({
    title: 'வரிகள் & பொருள்',
    description: 'அனைத்து பாடல் மற்றும் ஸ்துதி வரிகள் — தமிழ் பொருளுடன்.',
    path: '/lyrics',
  })

  return (
    <div className="page-hero">
      <div className="container section">
        <Breadcrumbs items={[{ label: 'முகப்பு', to: '/' }, { label: 'வரிகள் & பொருள்' }]} />
        <div className="section-header">
          <h1>வரிகள் & பொருள்</h1>
          <p>ஒவ்வொரு வரியையும் தொடர்ந்து பொருள் — மொபைலில் எளிதாகப் படிக்க.</p>
        </div>
        <div className="card-grid card-grid--3">
          {CONTENTS.map((item) => (
            <ContentCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </div>
  )
}
